import { useNavigate } from "react-router-dom"
import { Box, Button, Container, Grid, Stack, Typography } from "@mui/material"

import Background from "../../../assets/Background.jpg"
import NavbarOffset from "../../../components/NavbarOffset"
import { useEnquire } from "../../../components/EnquireModal"
import { homeCopy } from "../../../content/homeCopy"
import PromoBar from "./PromoBar"

const makeStyles = () => ({
    section: {
        width: "100%",
        minHeight: "100dvh",
        display: "flex",
        flexDirection: "column",
        backgroundImage: `linear-gradient(105deg, rgba(0, 4, 53, 0.92) 8%, rgba(0, 4, 53, 0.55) 55%, rgba(0, 4, 53, 0.25)), url('${Background}')`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        color: "text.primary",
    },
    heroBody: {
        flex: 1,
        display: "flex",
        alignItems: "center",
        width: "100%",
    },
    cta: {
        borderRadius: 999,
        textTransform: "none",
        fontWeight: 700,
        px: 3,
    },
})

const Header = () => {
    const navigate = useNavigate()
    const openEnquire = useEnquire()
    const styles = makeStyles()

    return (
        <Box component="section" sx={styles.section}>
            <NavbarOffset />
            <PromoBar />

            <Box sx={styles.heroBody}>
                <Container maxWidth="lg" sx={{ py: { xs: 6, md: 8 } }}>
                    <Grid container>
                        <Grid item xs={12} md={8} lg={7}>
                            <Stack direction="column" rowGap={3}>
                                <Typography
                                    variant="overline"
                                    sx={{ letterSpacing: "0.12em", color: "secondary.main", fontWeight: 700 }}
                                    data-aos="fade-right"
                                    data-aos-duration="900"
                                >
                                    {homeCopy.hero.overline}
                                </Typography>

                                <Typography
                                    variant="h2"
                                    fontWeight={800}
                                    data-aos="fade-right"
                                    data-aos-duration="1000"
                                    sx={{
                                        fontSize: { xs: "2.35rem", sm: "3rem", md: "3.4rem" },
                                        lineHeight: 1.1,
                                        maxWidth: 700,
                                    }}
                                >
                                    {homeCopy.hero.headline}
                                </Typography>

                                <Typography
                                    variant="h6"
                                    data-aos="fade-right"
                                    data-aos-duration="1000"
                                    sx={{ maxWidth: 540, opacity: 0.9, fontWeight: 400 }}
                                >
                                    {homeCopy.hero.subheadline}
                                </Typography>

                                <Stack
                                    direction={{ xs: "column", sm: "row" }}
                                    gap={1.5}
                                    data-aos="fade-right"
                                    data-aos-duration="1000"
                                >
                                    <Button
                                        size="large"
                                        variant="contained"
                                        color="secondary"
                                        sx={styles.cta}
                                        onClick={() => navigate("/vehicles")}
                                    >
                                        Browse vehicles
                                    </Button>
                                    <Button
                                        size="large"
                                        variant="outlined"
                                        color="secondary"
                                        sx={styles.cta}
                                        onClick={() => openEnquire?.()}
                                    >
                                        Enquire now
                                    </Button>
                                </Stack>
                            </Stack>
                        </Grid>
                    </Grid>
                </Container>
            </Box>
        </Box>
    )
}

export default Header
